var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounteroffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8315_2478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3 22.7C18.5 22.9 18.7 23 19 23C19.3 23 19.5 22.9 19.7 22.7L21 21.4L24.3 24.7C24.9 25.3 25.5 24.9 25.7 24.7L27.7 22.7C28.1 22.3 28.1 21.7 27.7 21.3L24.4 18L25.7 16.7C26.1 16.3 26.1 15.7 25.7 15.3L22.7 12.3C22.3 11.9 21.7 11.9 21.3 12.3L15.3 18.3C14.9 18.7 14.9 19.3 15.3 19.7L18.3 22.7ZM22 14.4L23.6 16L19 20.6L17.4 19L22 14.4Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 26H12V28H28V26Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3255 23.5443L13.569 21.666L12.6746 23.4548L16.4311 25.3331L17.3255 23.5443Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8315_2478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounteroffer);
export default __webpack_public_path__ + "static/media/counteroffer.c48d98ab59d1acae9e987848a7db3365.svg";
export { ForwardRef as ReactComponent };